import WarrantyDetailUi from "features/Warranty/Detail";
import React from "react";

const Detail = () => {
  return <WarrantyDetailUi />;
};

export default Detail;
